export default class Equipe {
  constructor(id, lider, descricao, data, custo) {
    this.id = id;
    this.lider = lider;
    this.descricao = descricao;
    this.data = data;
    this.custo = custo;
  }

  update(equipe) {
    this.id = equipe.id;
    this.lider = equipe.lider;
    this.descricao = equipe.descricao;
    this.data = equipe.data;
    this.custo = this.getCurrency(equipe.custo);
  }

  getCurrency(valor) {
    valor = parseFloat(valor).toFixed(2);
    var inteira = valor.substr(0, valor.length - 3);
    var ajuste = inteira.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var decimal = valor.substr(valor.length - 3, valor.length);
    decimal = decimal.replace(".", ",");
    return "R$ " + ajuste + decimal;
  }

  setNumber() {
    this.valor = Number(this.valor.replace("R$ ", "").replaceAll(".", "").replace(",", "."));
  }
}
